import { Pipe, PipeTransform } from '@angular/core';
import { DISPLAY_STATE, DISPLAY_STATES } from 'cargo-chief-commons';

/**
 * Renders a stored state the way it is written -- `GUA` as `Gto.` -- for the templates that build
 * `{{ city }}, {{ state }}` inline instead of going through FORMAT_LOCATION.
 *
 * Display only. Never bind this to a form control: the value typed back would be saved as `Gto.`,
 * which is the spelling CN-8913 exists to stop us storing.
 */
@Pipe({
	name: 'stateDisplay',
})
export class StateDisplayPipe implements PipeTransform {
	transform(value: string | null | undefined): string {
		return DISPLAY_STATE(value);
	}
}

/**
 * The same, for the comma-joined destination states a lane carries.
 */
@Pipe({
	name: 'statesDisplay',
})
export class StatesDisplayPipe implements PipeTransform {
	transform(value: string | null | undefined): string {
		return DISPLAY_STATES(value);
	}
}
